import type { CmFetchEnvelope } from './FetchResultPanel'

/** Normalize CM OkResult or flat Market-API payload for FetchResultPanel. */
export function toFetchEnvelope(data: unknown, sport?: string): CmFetchEnvelope {
  if (data && typeof data === 'object' && 'ok' in data && 'result' in data) {
    const d = data as { ok: boolean; sport?: string; result: unknown }
    return {
      ok: Boolean(d.ok),
      sport: d.sport ?? sport,
      result: d.result as CmFetchEnvelope['result'],
    }
  }
  if (data && typeof data === 'object') {
    const d = data as { ok?: boolean }
    return {
      ok: d.ok !== false,
      sport,
      result: data as CmFetchEnvelope['result'],
    }
  }
  return { ok: false, sport, result: null }
}
